<template>
  <v-container class="pa-0" fluid v-if="canView">
    <el-overlay-loading :loading="pageloading" />
    <registered-objects-form/>
    <registered-semiannually-form/>
    <registered-type-form/>
    <workload-form/>
    <pie-chart-form type="registered" />
    <pie-chart-form type="deregistered" />
    <pie-chart-form type="all" />
  </v-container>
</template>

<script>
import Roles from '@/components/constants/roles'
import RegisteredObjectsForm from './components/RegisteredObjectsForm.vue'
import PieChartForm from './components/PieChartForm.vue'
import RegisteredSemiannuallyForm from './components/RegisteredSemiannuallyForm.vue'
import RegisteredTypeForm from './components/RegisteredTypeForm.vue'
import WorkloadForm from './components/WorkloadForm.vue'
import ElOverlayLoading from "@/components/elements/ElOverlayLoading.vue";
export default { 
  name: 'Dashboard',
  components: {
    ElOverlayLoading,
    RegisteredObjectsForm,
    RegisteredSemiannuallyForm,
    RegisteredTypeForm,
    WorkloadForm,
    PieChartForm
  },
  data() {
    return {
      pageloading: false,
    }
  },
  computed: {
    canView() {
      const userRole = this.$store.getters.userRole
      return [Roles.IR_REGISTRATORIUS, Roles.IR_KAC_DARBUOTOJAS].some((item) => {
        return userRole.includes(item)
      });
    },
  },
  created() {
  },
  methods: {

  },
}
</script>
<style lang="scss" scoped></style>
